import { createAction, props } from '@ngrx/store';
import { Category } from '../models/category';

export const loadCategories = createAction('Load categories in app store', props<{ categories: Category[] }>());
export const loadSubCategories = createAction('Load sub-categories in app store', props<{ subCategories: string[] }>());
export const saveCategory = createAction('Save category in data base', props<{ category: Category }>());
// export const loadFeeds = createAction('Load Feeds', props<{ respServ: any }>());
// export const addFeeds = createAction('Add Feeds', props<{ feeds: Feed[] }>());
// export const updateFromDate = createAction('UPDATE_FROMDATE', props<{ date: string }>());
// export const updateToDate = createAction('UPDATE_TODATE', props<{ date: string }>());
